// The languages a code block in a blog post can be marked as — the picker on
// each block in the editor. The key is what the post stores
// (`<pre data-language="java">`) and what the website highlights it by.
//
// ⚠️ Twin of vc_cms lib/codeLanguages.js, which registers a highlighter for
// every key here and prints the label above the code. Change both.

export const CODE_LANGUAGES = [
  { key: "plain", label: "Plain text" },
  { key: "bash", label: "Bash / shell" },
  { key: "c", label: "C" },
  { key: "csharp", label: "C#" },
  { key: "cpp", label: "C++" },
  { key: "css", label: "CSS" },
  { key: "dart", label: "Dart" },
  { key: "go", label: "Go" },
  { key: "xml", label: "HTML / XML" },
  { key: "java", label: "Java" },
  { key: "javascript", label: "JavaScript" },
  { key: "json", label: "JSON" },
  { key: "kotlin", label: "Kotlin" },
  { key: "php", label: "PHP" },
  { key: "python", label: "Python" },
  { key: "r", label: "R" },
  { key: "ruby", label: "Ruby" },
  { key: "rust", label: "Rust" },
  { key: "sql", label: "SQL" },
  { key: "swift", label: "Swift" },
  { key: "typescript", label: "TypeScript" },
  { key: "yaml", label: "YAML" },
];

// What other sites and editors call the same languages, so code pasted from
// them keeps its language (`class="language-js"`, Quill's own `cs`).
const ALIASES = {
  text: "plain", txt: "plain", plaintext: "plain", none: "plain",
  sh: "bash", shell: "bash", zsh: "bash", console: "bash",
  cs: "csharp", "c#": "csharp",
  "c++": "cpp", cc: "cpp", cxx: "cpp", hpp: "cpp",
  golang: "go",
  html: "xml", xhtml: "xml", svg: "xml",
  js: "javascript", jsx: "javascript", mjs: "javascript", node: "javascript",
  kt: "kotlin",
  py: "python",
  rb: "ruby",
  rs: "rust",
  ts: "typescript", tsx: "typescript",
  yml: "yaml",
};

const LABELS = new Map(CODE_LANGUAGES.map(({ key, label }) => [key, label]));

/** Our key for a language name, or null for a language we do not offer. */
export function normalizeLanguage(name) {
  const n = String(name || "").trim().toLowerCase();
  if (!n) return null;
  if (LABELS.has(n)) return n;
  return ALIASES[n] || null;
}

export function languageLabel(key) {
  return LABELS.get(key) || "";
}
